(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('QueueAccount', QueueAccount);

    QueueAccount.$inject = ['$resource', 'DateUtils'];

    function QueueAccount ($resource, DateUtils) {
        var resourceUrl =  'api/queue-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtNascita = DateUtils.convertDateTimeFromServer(data.dtNascita);
                        data.dtIns = DateUtils.convertDateTimeFromServer(data.dtIns);
                        data.dtUpdate = DateUtils.convertDateTimeFromServer(data.dtUpdate);
                        data.recallDt = DateUtils.convertDateTimeFromServer(data.recallDt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
